"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGameCenter = void 0;
const detail_1 = require("./detail");
const email_1 = require("./email");
const reward_settings_1 = require("./reward-settings");
const user_base_1 = require("./user-base");
const popup_1 = require("./popup");
const gameModule_1 = require("./gameModule");
const adModule_1 = require("./adModule");
const textModule_1 = require("./textModule");
const rewardModule_1 = require("./rewardModule");
const reward_1 = require("./reward");
const game_1 = require("./game");
const player_1 = require("./player");
const player_verification_1 = require("./player-verification");
exports.defaultGameCenter = {
    detail: detail_1.detail,
    email: email_1.email,
    rewardSettings: reward_settings_1.rewardSettings,
    userBase: user_base_1.userBase,
    popup: popup_1.popup,
    gameModule: gameModule_1.gameModule,
    adModule: adModule_1.adModule,
    textModule: textModule_1.textModule,
    rewardModule: rewardModule_1.rewardModule,
    reward: reward_1.reward,
    player: player_1.player,
    playerVerification: player_verification_1.playerVerification,
    game: game_1.game,
};
